import Privacy from '../../components/legal/Privacy';

const PrivacyPolicyPage: React.FC = () => {
    return (<Privacy />);
}


export default PrivacyPolicyPage;